import { render, staticRenderFns } from "./Living.vue?vue&type=template&id=63e754b7&scoped=true"
import script from "./Living.vue?vue&type=script&lang=js"
export * from "./Living.vue?vue&type=script&lang=js"
import style0 from "./Living.vue?vue&type=style&index=0&id=63e754b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e754b7",
  null
  
)

export default component.exports